/**
 * "Import stubs" popup — opened from the payroll report (a missing week, a stub count…)
 * via ?tab=payroll&import=1. One tap opens the file picker (browsers need a real click),
 * or drop the PDFs/CSVs straight onto it.
 */
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FileUp, Upload } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function ImportStubsPrompt({ onChooseFiles, onFiles, busy }) {
  const [params, setParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const who = params.get("for");
  useEffect(() => { if (params.get("import")) setOpen(true); }, [params]);
  const close = () => {
    setOpen(false);
    const p = new URLSearchParams(params); p.delete("import"); p.delete("for"); setParams(p, { replace: true });
  };
  const drop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer?.files || []).filter((f) => /\.(pdf|csv)$/i.test(f.name));
    if (files.length) { onFiles(files); close(); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="bg-white text-gray-800 sm:max-w-md" data-testid="import-stubs-prompt">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><FileUp className="h-5 w-5 text-[#1a3fd1]" /> Import pay stubs{who ? ` for ${who}` : ""}</DialogTitle>
          <DialogDescription className="text-gray-500">Pay-stub PDFs or CSV exports. Each stub is scanned and matched to the employee named inside — duplicates are skipped.</DialogDescription>
        </DialogHeader>
        <div onDragOver={(e) => e.preventDefault()} onDrop={drop} data-testid="import-stubs-dropzone"
          className="flex flex-col items-center gap-3 rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 px-4 py-8 text-center">
          <Upload className="h-8 w-8 text-gray-400" />
          <p className="text-sm text-gray-600">Drop the files here, or</p>
          <button type="button" disabled={busy} onClick={() => { onChooseFiles(); close(); }} data-testid="import-stubs-choose"
            className="rounded-md bg-[#1a3fd1] px-4 py-2 text-sm font-semibold text-white hover:bg-[#1a3fd1]/90 disabled:opacity-50">
            {busy ? "Scanning…" : "Choose PDF / CSV files"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
